import { useLang } from "@/lib/lang";
import { Truck, Home, Utensils, MoonStar, Users, LineChart } from "lucide-react";

const ICONS = [Truck, Home, Utensils, MoonStar, Users, LineChart];

export default function USP() {
  const { t } = useLang();
  return (
    <section id="about" className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl">
          <div className="section-eyebrow">Why Dietwalaa</div>
          <h2 className="mt-3 font-display text-4xl md:text-5xl" style={{ color: "var(--primary)" }}>
            {t.usp.title}
          </h2>
        </div>
        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.usp.items.map((it, i) => {
            const Icon = ICONS[i];
            const big = i === 0 || i === 4;
            return (
              <div key={i} data-testid={`usp-${i}`} className={`card-soft p-8 ${big ? "lg:col-span-1" : ""}`}>
                <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ background: "var(--bg-paper)", color: "var(--primary)" }}>
                  <Icon size={22} />
                </div>
                <h3 className="mt-6 font-display text-2xl" style={{ color: "var(--primary)" }}>{it.t}</h3>
                <p className="mt-3 text-base leading-relaxed" style={{ color: "var(--text-secondary)" }}>{it.d}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
